import React, { Fragment } from 'react';
import {
  useAdvanceFilters,
  useGetUtilsKeys,
} from '../../../../share';
import { Row, Col, Button, Divider } from 'antd';
import {
  FormSelect,
  FormInput,
  FormDatePicker,
  CustomText,
} from '../../../../components';
import dayjs from 'dayjs';
import { DeleteOutlined } from '@ant-design/icons';
import { useAtom } from 'jotai';
import { authAtom } from '../../../../state';

const AdvancedFilters: React.FC<any> = ({
  states,
  formik,
  filters,
  setFilters,
  handleSearch,
  handleClearFilters,
  type,
  isViewMain = false,
  isGoods = false,
}: any) => {
  const [filterSelected, setFilterSelected] = React.useState<{
    name: string;
    id: string;
    type: string;
    fetchData?: any[];
  }>();

  const [authData] = useAtom(authAtom);
  
  const { data: utilKeys = [] } = useGetUtilsKeys(
    'keys[]=locations&keys[]=dependencies&keys[]=users',
  );
  const { data: advanceFilters } = useAdvanceFilters(
    type === 'Activo fijo' ? 'asset' : 'consumer-good'
  );

  const petitionTypes = [
    { id: 'refundpetition', name: 'Solicitudes de reintegro', perm: 'webportal-refund' },
    { id: 'goodpetition', name: 'Solicitudes de bienes', perm: 'webportal-consumables' },
    { id: 'entrypetition', name: 'Solicitudes de entradas', perm: 'webportal-entry' },
  ];

  const petitionableFetchData = authData?.superadmin
    ? petitionTypes
    : petitionTypes.filter(type => authData?.portalPermissions?.includes(type.perm));


  const filterOptions = [
    {
      name: 'Dependencia',
      id: 'dependency_id',
      type: 'select',
      fetchData: utilKeys?.dependencies || [],
    },
    {
      name: 'Ubicación',
      id: 'location_id',
      type: 'select',
      fetchData: utilKeys?.locations || [],
    },
    { name: 'Observaciones', id: 'observations', type: 'text' },
    {
      name: 'Solicitante',
      id: 'requester_id',
      type: 'select',
      fetchData: utilKeys?.users || [],
    },
    {
      name: 'Estado solicitud',
      id: 'status_id',
      type: 'select',
      fetchData: states?.filter((item: any) =>
        [9, 11, 16, 14, 12, 7, 10, 8, 28].includes(Number(item.id))
      ),
    },
    {
      name: 'Tipo de ticket',
      id: 'petitionable_type',
      type: 'select',
      fetchData: petitionableFetchData,
    },
  ];

  const handleAddFilter = () => {
    let item = {
      value: formik.values.filter_value,
      name: '',
      filter: { ...filterSelected },
    };

    if (filterSelected?.type === 'date') {
      item.value = dayjs(formik.values.filter_value).format('YYYY-MM-DD');
    }

    if (filterSelected?.type === 'select') {
      item.name = filterSelected?.fetchData?.find(
        (value) => value.id === formik.values.filter_value
      )?.name;
    }

    setFilters({ ...filters, [formik.values.filter_id]: item });

    setFilterSelected(undefined);
    formik.setFieldValue('filter_value', undefined);
    formik.setFieldValue('filter_id', undefined);
  };

  const handleRemoveFilter = (filterId: string) => {
    const filtersCopy = { ...filters };
    delete filtersCopy[filterId];

    setFilters({ ...filtersCopy });
  };

  return (
    <Fragment>
      <Row gutter={[16, 16]} align="middle" style={{ flexWrap: 'wrap', minWidth: 400 }}>
        <Col xs={24} sm={12}>
          <FormSelect
            label="Filtro avanzado"
            name="select_filter"
            placeholder="Seleccionar..."
            value={formik.values.filter_id}
            options={
              isViewMain
                ? filterOptions
                : advanceFilters?.map((filter) => ({
                    id: String(filter.value),
                    name: filter.label || '',
                    type: filter.type,
                  })).filter((item: any) => {
                    if (isGoods) {
                      return (item?.id !== 'sectional_search');
                    }
                    return true;
                  })
            }
            error={formik.errors.filter_id}
            touched={formik.touched.filter_id}
            onChange={(value) => {
              isViewMain
                ? setFilterSelected(
                    filterOptions.find((item) => item.id === value)
                  )
                : setFilterSelected(
                    advanceFilters
                      ? advanceFilters
                          .map((item) => ({
                            name: item.label || '',
                            id: String(item.value),
                            type: item.type || 'text',
                          }))
                          .find((item) => item.id === String(value)) ||
                          undefined
                      : undefined
                  );
              formik.setFieldValue('filter_value', '');
              formik.setFieldValue('filter_id', value);
            }}
            onBlur={formik.handleBlur}
          />
        </Col>
        <Col xs={24} sm={12}>
          {filterSelected?.type === 'select' && (
            <FormSelect
              label=""
              name="filter_value"
              placeholder="Seleccione"
              value={formik.values.filter_value}
              options={filterSelected?.fetchData || []}
              error={formik.errors.filter_value}
              touched={formik.touched.filter_value}
              onChange={(value) => formik.setFieldValue('filter_value', value)}
              onBlur={formik.handleBlur}
            />
          )}
          {filterSelected?.type === 'text' && (
            <FormInput
              label={''}
              name="filter_value"
              placeholder="Ingrese valor"
              value={formik.values.filter_value}
              error={formik.errors.filter_value}
              touched={formik.touched.filter_value}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          )}
          {filterSelected?.type === 'number' && (
            <FormInput
              label={''}
              name="filter_value"
              placeholder="Ingrese valor"
              value={formik.values.filter_value}
              error={formik.errors.filter_value}
              touched={formik.touched.filter_value}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          )}
          {filterSelected?.type === 'date' && (
            <FormDatePicker
              label=""
              name="filter_value"
              value={formik.values.filter_value}
              error={formik.errors.filter_value}
              touched={formik.touched.filter_value}
              onChange={(value) => formik.setFieldValue('filter_value', value)}
              onBlur={formik.handleBlur}
            />
          )}
          {filterSelected?.type === 'boolean' && (
            <FormSelect
              label=""
              name="filter_value"
              placeholder="Seleccione"
              value={formik.values.filter_value}
              options={[
                { id: String(true), name: 'Si' },
                { id: String(false), name: 'No' },
              ]}
              error={formik.errors.filter_value}
              touched={formik.touched.filter_value}
              onChange={(value) => formik.setFieldValue('filter_value', value)}
              onBlur={formik.handleBlur}
            />
          )}
        </Col>
        <Col xs={24} style={{ textAlign: "right", marginTop: 8, width: '100%' }}>
          <Button type="dashed" disabled={!formik.values.filter_value || !formik.values.filter_value} onClick={handleAddFilter} style={{ minWidth: 120 }}>
            Agregar Filtro
          </Button>
        </Col>
      </Row>
      <Divider />
      {Object.keys(filters).map((filterId: string) => {
        return (
          <Row gutter={[16, 16]} align="middle" key={filterId}>
            <Col
              xs={12}
              style={{
                border: '1px dashed rgb(168, 168, 168)',
                borderRadius: '5px',
                margin: '6px 4px',
                padding: '3px',
                backgroundColor: 'rgb(239, 240, 246)',
              }}
            >
              <CustomText
                strong={true}
                text={filters[filterId]?.filter?.name}
              />{' '}
            </Col>
            <Col
              xs={9}
              style={{
                border: '1px dashed rgb(168, 168, 168)',
                borderRadius: '5px',
                margin: '6px 4px',
                padding: '3px',
                backgroundColor: 'rgb(239, 240, 246)',
              }}
            >
              <CustomText
                text={
                  filters[filterId]?.value === 'true'
                    ? 'Si'
                    : filters[filterId]?.value === 'false'
                      ? 'No'
                      : filters[filterId]?.name || filters[filterId]?.value
                }
              />{' '}
            </Col>
            <Col xs={2} style={{ textAlign: 'right' }}>
              <Button
                type="link"
                onClick={() => handleRemoveFilter(filterId)}
                icon={<DeleteOutlined />}
              />
            </Col>
          </Row>
        );
      })}
      {!Object.keys(filters).length && (
        <CustomText
          strong={true}
          centered={true}
          text="No tiene filtros agregados"
        />
      )}

      <Divider />

      {!isViewMain && (
        <span style={{ display: 'flex', justifyContent: 'end', gap: '10px' }}>
          <Button
            type="dashed"
            onClick={handleClearFilters}
            style={{ marginTop: '15px', padding: '0 20px' }}
          >
            Limpiar
          </Button>
          <Button
            type="primary"
            onClick={handleSearch}
            style={{ marginTop: '15px', padding: '0 20px' }}
          >
            Buscar
          </Button>
        </span>
      )}
    </Fragment>
  );
};

export default AdvancedFilters;
